import API from 'src/api'
import { http } from '../boot/axios'
// Utils
import utils from '@/utils'

export default {
  URL: API.URL + 'organizations/',
  GRAPHQL_URL: `${API.GRAPHQL_URL}organizations`,
  fetch (options = {}) {
    const { page, search, limit } = {
      ...{
        page: 1,
        search: null,
        limit: 1000
      },
      ...options
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}?limit=${limit}&page=${page}` + (search ? `&search=${search}` : ''))
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  fetchUsers (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}${id}/users`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      http.post(this.URL + 'make', payload)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  find (organizationId) {
    return new Promise((resolve, reject) => {
      http.get(this.GRAPHQL_URL + '/' + organizationId)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  update (payload) {
    // delete payload['values']
    // delete payload['updated_at']
    // delete payload['created_at']
    // delete payload['client_number']
    const organization = new FormData()
    organization.append('name', payload.name)
    organization.append('username', payload.username)
    organization.append('address', payload.address)
    organization.append('rfc', payload.rfc)
    organization.append('organization_description', payload.organization_description)
    organization.append('sector', payload.sector)
    organization.append('client_id', payload.client_id)
    organization.append('sales_agent_id', payload.sales_agent_id)
    organization.append('country', payload.country)
    organization.append('activation_date', payload.activation_date)
    organization.append('bank', payload.bank)
    organization.append('last_digits', payload.last_digits)
    organization.append('contact_info', JSON.stringify(payload.contact_info))
    organization.append('channel', payload.channel)
    organization.append('address_json', JSON.stringify(payload.address_json))
    organization.append('status', payload.status)
    organization.append('payment_method', payload.payment_method)
    organization.append('payment_form', payload.payment_form)
    organization.append('cfdi_use', payload.cfdi_use)
    organization.append('payment_deadline', payload.payment_deadline)
    if (payload.logo instanceof File || payload.logo instanceof Blob) {
      organization.append('logo', payload.logo, payload.logo.name || 'logo.jpg')
    } else if (typeof payload.logo === 'string' && payload.logo.startsWith('data:image')) {
      organization.append('logo', utils.dataUrlToBlob(payload.logo), 'logo.jpg')
    }
    organization.append('_method', 'put')

    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${payload.id}`, organization)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  configure (payload) {
    const form = new FormData()
    const id = payload.id
    form.append('data', payload.data)
    form.append('organization_id', payload.id)
    form.append('type', payload.type)
    return new Promise((resolve, reject) => {
      http.post(this.GRAPHQL_URL + '/' + id + '/config', form)
        .then((data) => { resolve(data) })
        .catch((err) => { reject(err) })
    })
  },
  getGeneralSettings (id, type, config = {}) {
    return new Promise((resolve, reject) => {
      if (!id) {
        reject(new Error('organizationService.getGeneralSettings: id vacio o indefinido, peticion cancelada'))
        return
      }
      http.get(`${this.GRAPHQL_URL}/${id}/config/?type=${type}`, config)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  configureSettings (id, payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${id}/config`, payload)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  addAPCategory (id, category, type) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${id}/config/add-apcategory`, {category, type})
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  deleteAPCategory (id, category, type) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${id}/config/delete-apcategory`, {data: {category, type}})
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  changeCategory (id, oldCategory, newCategory, type) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${id}/config/change-apcategory`, {oldCategory, newCategory, type})
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateFormCategory (organizationId, oldCategory, newCategory) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${organizationId}/config/update-formcategory`, { oldCategory, newCategory })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteFormCategory (organizationId, category) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${organizationId}/config/delete-formcategory`, { data: { category } })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  updateItemResponsability (organizationId, oldResponsability, newResponsability) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${organizationId}/config/update-itemresponsability`, { oldResponsability, newResponsability })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteItemResponsability (organizationId, responsability) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${organizationId}/config/delete-itemresponsability`, { data: { responsability } })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  addSprintWindow (id, sprintWindow) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${id}/config/add-sprint-window`, {sprintWindow})
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  deleteSprintWindow (id, sprint_window) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${id}/config/delete-sprint-window`, {data: {sprint_window}})
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getDemoUsers (organizationId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/users-demo`, {
        organization_id: organizationId
      })
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getDocuments (organizationId) {
    return http.get(`${this.URL}${organizationId}/documents`)
  },
  getSectors () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/sectors/list`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  updateItemLeadership (organizationId, oldLeadership, newLeadership) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${organizationId}/config/update-itemleadership`, { oldLeadership, newLeadership })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  update2FA (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/config/update-2fa`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteItemLeadership (organizationId, leadership) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${organizationId}/config/delete-itemleadership`, { data: { leadership } })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getOrganizations () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/all`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchPaginated (options = {}) {
    let { page, search, limit, franchise_id, organization_id } = {
      ...{
        page: 1,
        search: null,
        limit: 30,
        franchise_id: null,
        organization_id: null
      },
      ...options
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/?limit=${limit}&page=${page}`
        + (search ? `&search=${search}` : '')
        + (organization_id ? `&organization_id=${organization_id}` : '')
        + (franchise_id ? `&franchise_id=${franchise_id}` : '')
      )
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  getOrganizationstoDropdown () {
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}getOrganizations`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getFranchisestoDropdown (id) {
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}getFranchises/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getUserByFranchises (id) {
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}getUserByFranchises/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getUserByOrganizations (id) {
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}getOrganizationUsers/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateStatus (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${API.GRAPHQL_URL}updateUserStatus/${payload.id}`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getEnableFranchise (id) {
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}getEnableFranchise/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateEnabledUserFranchises (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${API.GRAPHQL_URL}updateFranchiseUsersStatus/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  saveSemaphoreSprints (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/settings/saveSemaphore`, payload)
        .then(res => resolve(res.data.data))
        .catch(err => reject(err))
    })
  },
  getSemaphoreSprints () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/settings/getSemaphore`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  saveDemoDate (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/set-demo-dates`, payload)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => reject(err))
    })
  },
  getCategoryAreas (organizationId, category) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${organizationId}/config/category-areas?category=${category}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  saveCategoryAreas (organizationId, category, areas) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${organizationId}/config/category-areas`, { category, areas })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getAllCategoryAreas (organizationId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${organizationId}/config/all-category-areas`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getAreasForCategories (organizationId, categories) {
    if (!categories || categories.length === 0) {
      return Promise.resolve([])
    }
    if (categories.length === 1) {
      return this.getCategoryAreas(organizationId, categories[0])
    }
    const promises = categories.map(category =>
      this.getCategoryAreas(organizationId, category)
    )
    return Promise.all(promises).then(results => {
      if (results.length === 0) return []
      const allAreas = results.flat()
      return [...new Set(allAreas)]
    })
  }
}
